<div>
  <div class="title-section">
    <span class="title text-capitalize">{{ 'delete user' | translate }}</span>
  </div>

  <div class="delete-section text-center">
    <div class="delete-icon">
      <div class="pictures">
        <div class="picture _first" *ngIf="users[users.length - 1]">
          <app-profile-photo
            [user]="users[users.length - 1]"
            [width]="48"
            [isClickEnabled]="false"
          ></app-profile-photo>
        </div>
        <div class="picture _second" *ngIf="users[users.length - 2]">
          <app-profile-photo
            [user]="users[users.length - 2]"
            [width]="48"
            [isClickEnabled]="false"
          ></app-profile-photo>
        </div>
        <div class="picture _third" *ngIf="users[users.length - 3]">
          <app-profile-photo
            [user]="users[users.length - 3]"
            [width]="48"
            [isClickEnabled]="false"
          ></app-profile-photo>
        </div>
      </div>
      <div class="status justify-content-center align-items-center">
        <i class="material-icons icon">close</i>
      </div>
    </div>
    <div class="delete-text d-inline justify-content-center cpx-24">
      {{ 'Are you sure you want to delete' | translate }}
      <div class="name">
        {{ users.length > 1 ? users.length + ' users' : users[0].name }}
      </div>
      {{ '?' }}
    </div>
    <div class="note">{{ 'User(s) will no longer have access to institution' | translate }}</div>
    <div class="delete-note">
      <textarea [placeholder]="'Add note (optional)' | translate" [(ngModel)]="additionalNote"></textarea>
    </div>
  </div>

  <div class="buttons text-center cpt-32 cpb-24">
    <button mat-flat-button class="btn-cancel cmr-16" (click)="close()">
      <i class="material-icons">close</i>
      <span class="text-capitalize">{{ 'cancel' | translate }}</span>
    </button>

    <button mat-flat-button class="btn-invite" color="primary" (click)="submit()">
      <i class="material-icons-outlined">done</i>
      <span class="text-capitalize">{{ 'Yes, i’m sure' | translate }}</span>
    </button>
  </div>
</div>
